"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimilarToKitSearchResponse = void 0;
const common_1 = require("../../common");
const similar_to_kit_data_response_1 = require("./similar-to-kit-data.response");
class SimilarToKitSearchResponse extends common_1.PaginatedResponse {
}
exports.SimilarToKitSearchResponse = SimilarToKitSearchResponse;
//# sourceMappingURL=similar-to-kit-search.response.js.map